import { render } from "./PhasesTable.vue?vue&type=template&id=62c9bff7&scoped=true"
import script from "./PhasesTable.vue?vue&type=script&lang=js"
export * from "./PhasesTable.vue?vue&type=script&lang=js"

import "./PhasesTable.vue?vue&type=style&index=0&id=62c9bff7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c9bff7"]])

export default __exports__
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QVirtualScroll,QTr,QTh,QTd,QCheckbox,QIcon,QTooltip,QBtn,QTable});
